import running from '../../assets/running.png';

import '../../styles/days.scss';

const TwentyTwo = () => (
  <div className='days full-image rounded'>
    <img src={running} alt='running' />
  </div>
);

export default TwentyTwo;
